import { render } from "./ModalUpdatePerson.vue?vue&type=template&id=5059c9a2"
import script from "./ModalUpdatePerson.vue?vue&type=script&lang=js"
export * from "./ModalUpdatePerson.vue?vue&type=script&lang=js"

import "./ModalUpdatePerson.vue?vue&type=style&index=0&id=5059c9a2&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__